<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree @clickByOrg="queryAccountList" :isAll="1" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-yonghu el-icon--left"></i>账户
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入编码或姓名" v-model="queryObj.keyWord" size="small" class="query" style="float: left"
              clearable @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadAccountList();
                }
              ">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" icon="el-icon-font el-icon-web__tianjia" size="mini" style="margin-right: 6px"
              @click="add_init">新增</el-button>
            <!-- :disabled="!funcs.includes('bbb')" -->
            <es-delete @del="del()" type="button"></es-delete>
          </div>
          <el-table :data="pageData.list" ref="accountTable" border stripe size="mini" height="calc(100vh - 250px)"
            v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="loginNo" width="160" label="账号">
            </el-table-column>
            <el-table-column prop="userName" width="160" label="姓名">
            </el-table-column>
            <el-table-column prop="roleName" label="角色名称"> </el-table-column>
            <el-table-column prop="userAttribute" width="120" label="账户属性">
              <template slot-scope="scope">
                <span v-if="scope.row.userAttribute == 0">现场</span>
                <span v-if="scope.row.userAttribute == 1">管理</span>
              </template>
            </el-table-column>
            <el-table-column prop="orgName" width="150" label="所属组织">
            </el-table-column>
            <el-table-column label="操作" width="160" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
                    class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)" :key="scope.row.id" type="icon"></es-delete>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" title="设置密码" @click="resetPassword_init(scope.row)" type="primary"><i
                    class="el-icon-lock"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" title="用户授权" @click="setAuth_init(scope.row)" type="primary"><i
                    class="el-icon-font el-icon-quanxian"></i></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData" @change="
              (cpage) => {
                this.queryObj.pageNum = cpage;
                this.loadAccountList();
              }
            ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑用户-->
    <el-dialog :visible.sync="editVisible" @closed="() => this.$refs['AccountForm'].clearValidate()" width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑用户
      </span>
      <el-form :model="accountInfo" :rules="editRules" size="mini" label-position="right" label-width="150px"
        ref="accountForm">
        <el-form-item prop="loginNo" label="账号">
          <el-input v-model="accountInfo.loginNo" placeholder="请输入账号" style="width: 200px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="userName" label="姓名">
          <el-input v-model="accountInfo.userName" placeholder="请输入姓名" style="width: 200px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="userAttribute" label="账户属性">
          <el-select v-model="accountInfo.userAttribute" style="width: 200px" placeholder="请选择">
            <el-option label="现场" :value="0"></el-option>
            <el-option label="管理" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orgId" label="所属组织">
          <el-cascader ref="orgId" v-model="accountInfo.orgId" :show-all-levels="false"
            :props="{ value: 'id', checkStrictly: true }" :options="orgTree" filterable style="width: 200px">
          </el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitAccount()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
    <!--设置密码-->
    <el-dialog :visible.sync="resetPasswordVisible" @closed="() => this.$refs['passwordForm'].clearValidate()"
      width="500px">
      <span slot="title">
        <i class="el-icon-lock el-icon--left"></i>设置密码
      </span>
      <el-tag type="warning" style="margin-bottom: 12px">密码中必须包含大小写字母、数字、特殊字符。至少8个字符、最多20个字符。</el-tag>
      <el-form :model="accountInfo" :rules="pwRules" size="mini" label-position="right" label-width="150px"
        ref="passwordForm">
        <el-form-item prop="password" label="新密码">
          <el-input v-model="accountInfo.password" placeholder="请输入新密码" style="width: 200px" show-password clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密码">
          <el-input v-model="accountInfo.confirmPassword" placeholder="请确认新密码" style="width: 200px" show-password
            clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="resetPasswordVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitPassword()" :loading="savingPw">保 存</el-button>
      </span>
    </el-dialog>
    <!--设置权限-->
    <el-dialog :visible.sync="setAuthVisible"
      @closed="() => { this.$refs['setAuthForm'].clearValidate(); this.clearSelectionTable() }" width="800px">
      <span slot="title">
        <i class="el-icon-lock el-icon--left"></i>设置权限【{{
          accountInfo.loginNo
        }}】
      </span>

      <el-form :model="accountInfo" :rules="pwRules" size="small" label-position="right" label-width="150px"
        ref="setAuthForm">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-card class="card" style="overflow: auto; height: calc(100vh - 350px)">
              <div slot="header" class="card-header">
                <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>角色权限
              </div>
              <el-table :data="roleListAll" ref="roleTable" border stripe size="mini" height="calc(100vh - 415px)"
                v-loading="loading">
                <!-- @select="selectRoleIds"
                @sselect-all="selectRoleIds" -->
                <el-table-column type="selection" width="40" align="center">
                </el-table-column>
                <el-table-column prop="name" label="角色名称">
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8" style="overflow: auto; height: calc(100vh - 348px)">
            <el-card class="card" style="overflow: auto; height: calc(100vh - 350px)">
              <div slot="header" class="card-header">
                <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>系统权限
              </div>
              <el-table :data="sysListAll" ref="sysTable" border stripe size="mini" height="calc(100vh - 415px)"
                v-loading="loading">
                <!-- @select="selectSystemIds"
                @sselect-all="selectSystemIds" -->
                <el-table-column type="selection" width="40" align="center">
                </el-table-column>
                <el-table-column prop="name" label="系统名称">
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="card" style="overflow: auto; height: calc(100vh - 350px)">
              <div slot="header" class="card-header">
                <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>组织权限
              </div>
              <div style="overflow: auto; height: calc(100vh - 415px)">
                <es-org-tree v-if="flag" :isAll="1" @clickByOrg="selectOrgIdsList" :checkedKeys="checkedKeys"
                  :checkstrictly="false" ref="orgTreeChildren"></es-org-tree>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="setAuthVisible = false;">取 消</el-button>
        <el-button type="primary" size="mini" :loading="savingAuther" @click="submitAuther()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "account",
  props: ["funcs"],
  data () {
    //自定义密码验证
    let validatePassword = (rule, value, callback) => {
      var regExp = new RegExp(
        "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}"
      );
      if (!regExp.test(value)) {
        callback(new Error("密码复杂度不够，请重新输入"));
      } else {
        callback();
      }
    };
    //自定义确认密码
    let validateConfirmPassword = (rule, value, callback) => {
      if (this.accountInfo.password != value) {
        callback(new Error("确认密码跟新密码不一致"));
      } else {
        callback();
      }
    };
    return {
      flag: false,
      orgTree: [],
      checkedKeys: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      accountInfo: {}, //用户信息
      editRules: {
        //验证条件
        loginNo: [
          { required: true, message: "请输入员工号", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
        userAttribute: [{ required: true, message: "请选择账户属性", trigger: "blur" }],
        orgId: [{ required: true, message: "请选择所属组织", trigger: "blur" }],
      },
      pwRules: {
        //验证条件
        password: [
          { required: true, validator: validatePassword, trigger: "blur" },
        ],
        confirmPassword: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
      resetPasswordVisible: false, //设置密码显示
      setAuthVisible: false, //设置权限弹框显示
      loading: false,
      saving: false,
      savingPw: false,
      savingAuther: false,
      roleListAll: [],
      sysListAll: [],
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadAccountList();
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree;
    },
    queryAccountList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadAccountList();
    },
    //从后台查询账户列表
    loadAccountList () {
      this.loading = true;
      this.$ajax
        .get("/base/account/list", this.queryObj)
        .then((msg) => {
          msg.list.forEach(item => {
            if (item.rolesName != null && item.rolesName.length > 0) {
              item.roleName = item.rolesName.toString()
            }
          })
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加账户
    add_init () {
      this.editVisible = true;
      this.accountInfo = {};
    },
    //初始化编辑账户
    edit_init (row) {
      this.editVisible = true;
      this.accountInfo = JSON.parse(JSON.stringify(row));
    },
    //保存账户信息
    submitAccount () {
      this.$refs["accountForm"].validate((valid) => {
        if (valid) {
          this.accountInfo.orgId = this.$refs.orgId.getCheckedNodes()[0].value;
          let account = JSON.parse(JSON.stringify(this.accountInfo));
          let url = "/base/account/add";
          if (account.id != null) {
            url = "/base/account/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, account)
            .then((msg) => {
              this.saving = false;
              this.loadAccountList();
              this.editVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除用户信息
    del (delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["accountTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/base/account/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadAccountList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    //初始化设置密码
    resetPassword_init (row) {
      this.resetPasswordVisible = true;
      this.accountInfo = { id: row.id };
    },
    setAuth_init (row) {
      this.flag = false;
      console.log("setAuth_init", row);
      this.checkedKeys = [];
      this.$ajax
        .post("/base/account/getUserDetailsByAccountCode", row)
        .then((msg) => {
          this.accountInfo = msg;
          this.toggleRoleSelection(msg.roles);
          this.toggleSysSelection(msg.systems);
          this.flag = true;
          this.checkedKeys = msg.orgs;
          // console.log("org",msg.orgs);
          // this.toggleOrgSelection(msg.orgs);
          this.setAuthVisible = true;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    toggleRoleSelection (roles) {
      console.log("toggleRoleSelection", roles);
      roles.forEach((item) => {
        // checkedData为已选数据
        this.$nextTick(() => {
          this.roleListAll.find((obj) => {
            // userData 表单数据
            if (item === obj.id) {
              this.$refs.roleTable.toggleRowSelection(obj, true);
            }
          });
        });
      });
    },
    toggleSysSelection (systems) {
      console.log("toggleSysSelection", systems);
      systems.forEach((item) => {
        // checkedData为已选数据
        this.$nextTick(() => {
          this.sysListAll.find((obj) => {
            // userData 表单数据
            if (item === obj.id) {
              this.$refs.sysTable.toggleRowSelection(obj, true);
            }
          });
        });
      });
    },
    clearSelectionTable () {
      this.setAuthVisible = false;
      this.$nextTick(() => {
        this.$refs.roleTable.clearSelection();
      });
      this.$nextTick(() => {
        this.$refs.sysTable.clearSelection();
      });
    },
    toggleOrgSelection (orgs) {
      console.log("toggleOrgSelection", orgs);
      this.$nextTick(function () {
        console.log("orgTree", this.$refs.orgTreeChildren.$refs.orgTree);
        console.log("orgTree", this.$refs.orgTreeChildren.$refs.orgTree.data);
        this.$refs.orgTreeChildren.$refs.orgTree.setCurrentKey(orgs);
      });
    },
    selectRoleIds () {
      this.accountInfo.roles = [];
      let rolesIdList = [];
      this.$refs["roleTable"].selection.forEach((ele) => {
        rolesIdList.push(ele.id);
      });
      this.accountInfo.roles = rolesIdList;
      console.log("selectRoleIds", this.accountInfo);
    },
    selectSystemIds () {
      this.accountInfo.systems = [];
      let systemIdList = [];
      this.$refs["sysTable"].selection.forEach((ele) => {
        systemIdList.push(ele.id);
      });
      this.accountInfo.systems = systemIdList;
      console.log("selectSystemIds", this.accountInfo);
    },
    selectOrgIdsList (orgIds) {
      this.accountInfo.orgs = orgIds;
      console.log("selectOrgIdsList", this.accountInfo);
    },
    /**
     * 查询初始化全部角色信息
     */
    queryRoleList () {
      this.$ajax
        .get("/base/role/listAll")
        .then((msg) => {
          console.log("queryRoleList", msg);
          this.roleListAll = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    /**
     * 查询初始化全部系统信息
     */
    querySysList () {
      this.$ajax
        .get("/base/system/listAll")
        .then((msg) => {
          console.log("sysListAll", msg);
          this.sysListAll = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    /**
     * 提交设置权限信息
     */
    submitAuther () {
      this.selectRoleIds();
      this.selectSystemIds();
      this.savingAuther = true;
      this.$ajax
        .post("/base/account/save_auther", this.accountInfo)
        .then((msg) => {
          this.loadAccountList();
          this.$message.success(msg);
          this.savingAuther = false;
          this.clearSelectionTable();
        })
        .catch((err) => {
          this.$message.error(err);
          this.savingAuther = false;
        });
    },
    //保存密码信息
    submitPassword () {
      this.$refs["passwordForm"].validate((valid) => {
        if (valid) {
          this.savingPw = true;
          this.$ajax
            .post("/base/account/reset_password", this.accountInfo)
            .then((msg) => {
              this.savingPw = false;
              this.loadAccountList();
              this.resetPasswordVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
  },
  created () {
    this.queryRoleList();
    this.querySysList();
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped></style>
